import React from "react";
import {WhiteTooltip} from "../../../../../elements/tooltip/WhiteTooltip";
import styles from "./HelpTooltip.module.css";

interface HelpTooltipProps {
    text: string;
}

export const HelpTooltip: React.FC<HelpTooltipProps> = ({text}) => (
    <WhiteTooltip title={<span className={styles.tooltipText}>{text}</span>}>
        <span className={styles.helpIconWrapper}>
            <span className={styles.helpIcon} aria-label="Metric description">?</span>
        </span>
    </WhiteTooltip>
);
